/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NativeWidgetToken } from '../models/NativeWidgetToken';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NativeWidgetService {
    /**
     * Create Update Widget Token
     * @param requestBody
     * @returns NativeWidgetToken Successful Response
     * @throws ApiError
     */
    public static createUpdateWidgetTokenNativeWidgetPost(
        requestBody: NativeWidgetToken,
    ): CancelablePromise<NativeWidgetToken> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/native_widget/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
